// Workflow Templates Service for backend communication
import { api } from './api';

export type ProjectCategory = 'Opus' | 'Piece';

export interface WorkflowTemplateDto {
  id: string;
  name: string;
  projectType: string;
  category: ProjectCategory;
  isCustom: boolean;
  stages: string[];
  createdAt: string;
  userId?: string;
}

// Helper to check if a template is a system template
export const isSystemTemplate = (template: WorkflowTemplateDto): boolean => !template.isCustom;

export interface CreateWorkflowTemplateRequest {
  name: string;
  projectType: string;
  stages: string[];
}

export interface UpdateWorkflowTemplateRequest {
  name: string;
  stages: string[];
}

// Workflow Templates API
export const workflowTemplatesApi = {
  // Get all templates (system + user's custom)
  getAll: (projectType?: string, category?: ProjectCategory): Promise<WorkflowTemplateDto[]> => {
    const params = new URLSearchParams();
    if (projectType) params.append('projectType', projectType);
    if (category) params.append('category', category);
    const queryString = params.toString();
    return api.get<WorkflowTemplateDto[]>(`/workflowtemplates${queryString ? `?${queryString}` : ''}`);
  },

  // Get system templates only
  getSystemTemplates: (projectType?: string, category?: ProjectCategory): Promise<WorkflowTemplateDto[]> => {
    const params = new URLSearchParams();
    if (projectType) params.append('projectType', projectType);
    if (category) params.append('category', category);
    const queryString = params.toString();
    return api.get<WorkflowTemplateDto[]>(`/workflowtemplates/system${queryString ? `?${queryString}` : ''}`);
  },

  // Get template by ID
  getById: (id: string): Promise<WorkflowTemplateDto> => {
    return api.get<WorkflowTemplateDto>(`/workflowtemplates/${id}`);
  },

  // Create a custom template
  create: (data: CreateWorkflowTemplateRequest): Promise<WorkflowTemplateDto> => {
    return api.post<WorkflowTemplateDto>('/workflowtemplates', data);
  },

  // Update a custom template
  update: (id: string, data: UpdateWorkflowTemplateRequest): Promise<WorkflowTemplateDto> => {
    return api.put<WorkflowTemplateDto>(`/workflowtemplates/${id}`, data);
  },

  // Delete a custom template
  delete: (id: string): Promise<void> => {
    return api.delete<void>(`/workflowtemplates/${id}`);
  },
};

export default workflowTemplatesApi;
